import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";


const TrocaSenha = ({ user, onClose, isRecovery = false }) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (password !== confirmPassword) {
      setError("As senhas não coincidem.");
      return;
    }

    if (password.length < 6) {
      setError("A senha deve ter no mínimo 6 caracteres.");
      return;
    }

    setLoading(true);

    const { error: updateError } = await supabase.auth.updateUser({
      password: password,
    });

    if (updateError) {
      setError(updateError.message);
    } else {
      setSuccess(
        isRecovery
          ? "Senha redefinida com sucesso! Redirecionando para o login..."
          : "Senha alterada com sucesso!"
      );
      setPassword("");
      setConfirmPassword("");
      setTimeout(() => {
        onClose();
      }, 2000);
    }

    setLoading(false);
  };

  const title = isRecovery ? "Redefinir Senha" : "Alterar Senha";
  const buttonText = isRecovery ? "Redefinir Senha" : "Alterar Senha";
  const inputCls = "h-11 w-full rounded-lg border border-slate-300 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#4a4e91]/20 focus:border-[#4a4e91] transition";
  const primaryBtn = "h-11 rounded-xl bg-rose-400 text-white font-semibold text-sm hover:brightness-105 transition disabled:opacity-70 px-6";
  const secondaryBtn = "h-11 rounded-xl bg-slate-200 text-slate-700 font-semibold text-sm hover:bg-slate-300 transition px-6";

  const content = (
    <div>
      <h2 className="text-xl font-bold text-slate-800 mb-5 text-center">{title}</h2>
      <form onSubmit={handlePasswordChange} className="flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <label htmlFor="new-password" className="text-xs font-semibold text-slate-700">Nova Senha</label>
          <input
            id="new-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className={inputCls}
          />
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="confirm-password" className="text-xs font-semibold text-slate-700">Confirmar Nova Senha</label>
          <input
            id="confirm-password"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            className={inputCls}
          />
        </div>
        {error && <p className="text-xs text-red-600">{error}</p>}
        {success && <p className="text-xs text-green-600">{success}</p>}
        <div
          className="flex gap-3 mt-1"
          style={{ justifyContent: isRecovery ? "center" : "space-between" }}
        >
          <button type="submit" className={primaryBtn} disabled={loading}>
            {loading ? "Aguarde..." : buttonText}
          </button>
          {!isRecovery && (
            <button type="button" className={secondaryBtn} onClick={onClose}>
              Cancelar
            </button>
          )}
        </div>
      </form>
    </div>
  );

  if (isRecovery) {
    return <div>{content}</div>;
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-2xl p-6 w-full max-w-sm shadow-xl">{content}</div>
    </div>
  );
};

export default TrocaSenha;
